<script>
import DialogDate from '../components/DialogDate'
import router from "@/router";
import SelectCustomer from "@/components/SelectCustomer.vue";

export default {
  name: 'FormCISAccount',
  
  components: {
    SelectCustomer,
    DialogDate
  },

  data () {
    return {
      title: 'CIS-Account',
      table: 'cis_user',
      mainview: 'ListCISAccounts',
      id: '',
      email: '',
      password: '',
      note: '',
      group: [], 
      customer: '',
      customer_id : '',
      company : '',
      customers: [],
      type: '',
      groups: [],
      SelectCustomer: false,
    }
  },

  async created() {
    await Promise.all([this.loadGroupTypes()]);
    if (this.$route.params.id) {
      this.id = this.$route.params.id
      this.fetchCisAccount();
    } 
  },

  methods: {

    async loadCustomer(customerId) {
      console.log('Customer ID selected:', customerId);
      
      if (!customerId) {
        console.error('No customer ID received');
        return;
      }
      const param = {
        table: "customer",
        statement: "select",
        type: "detail",
        where: "true",
        selector: "id",
        value: customerId,
        short: "false",
        extension: ""
      };

      try {
        const result = await this.$func.queryAPI(param, {});
        if (Array.isArray(result) && result.length > 0) {
          const customerData = result[0];
          console.log('Fetched customer data:', customerData);
          
          this.customer_id = customerId;
          this.customer = customerId;
          this.company = customerData.company || customerData.name || '';//checkk

          console.log('Updated customer fields:', {
            customer_id: this.customer_id,
            customer: this.customer,
            company: this.company
          });
        }
      } catch (error) {
        console.error('Error fetching customer details:', error);
      }

      this.SelectCustomer = false;
    },


    btnCancel(){
      router.push({ name: this.mainview });
    },

    async loadGroupTypes() {
      console.log("Loading group types...");
      const param = {
        table: "group_type",
        statement: "select",
        type: "list",
        where: "",
        selector: "1",
        value: "1",
        short: "false",
        extension: ""
      };

      const data = {};

      try {
        const result = await this.$func.queryAPI(param, data);

        if (Array.isArray(result) && result.length > 0) {
          this.groups = result.map(group => {
            return {
              id: Number(group.id),
              name: group.name || "Unknown Group"
            };
          });
          console.log("List groups:", this.groups);
        } else {
          console.warn("No group data found:", result);
          this.groups = [];
        }
      } catch (error) {
        console.error("Error fetching groups:", error);
        this.groups = [];
      }
    },

  async saveData() {
  console.log('Saving CIS account...');
  var statement

if(this.id == ""){
  statement = "insert"
}else{
  statement = "update"
}

  const param = {
    table: this.table,
    statement: statement,
    type: "",
    where: "true",
    selector: "id",
    value: this.id,
    short: "true",
    extension: ""
  };

  //const lastLogin = new Date().toISOString().slice(0, 19).replace('T', ' ');
  const data = {
        email: this.email,
        password: this.password,
        note: this.note,
        type: this.type,
        
      };

      if (this.type === 'single') {
        data.customer_id = this.customer_id;
        data.company = this.company;
        console.log('Adding customer data:', {
          customer_id: data.customer_id,
          company: data.company
        });
      }

      if (this.type === 'group' && Array.isArray(this.group)) {
        data.groupe_type_id = this.group.join(',');
        data.company = "";
      }


  try {
    const result = await this.$func.queryAPI(param, data);
    console.log("CIS user saved successfully:", result);
   
    this.$router.push({ name: this.mainview });
  } catch (error) {
    console.error("Error updating CIS user:", error);
    
  }
},


 async fetchCisAccount() {
  console.log('Fetching CIS account for ID:', this.id);

  const param = {
    table: this.table,
    statement: "select",
    type: "detail",
    where: "true",
    selector: "id",
    value: this.id,
    short: "false",
    extension: ""
  };

  try {
    const result = await this.$func.queryAPI(param, {});

    if (Array.isArray(result) && result.length > 0) {
      const account = result[0];
      console.log("Fetched CIS account:", account);

      this.email = account.email || '';
      this.password = account.password || '';
      if (this.type === 'group' && account.groupe_type_id) {
            const groupIds = account.groupe_type_id.split(',').map(id => Number(id));
            console.log("Group IDs from account:", groupIds);
            this.group = groupIds;
            console.log("groups :", this.group);
          }
      

      this.customer = account.customer_id || '';
      this.company = account.company || '';
      this.note = account.note || '';
      this.type = account.type || '';

    } else {
      console.warn("No CIS account data found.");
    }
  } catch (error) {
    console.error("Error fetching CIS account:", error);
  }
}

},

watch: {
  id: {
    immediate: true,  
    handler(newId) {
      if (newId) {
        this.fetchCisAccount();
      }
    }
  },

}
      
}
</script>

<template>
  <v-layout>
    <v-card 
      class="mx-auto justify-center text-center"
      width="600"
      style="padding-top: 30px;"
      elevation="10"
    >
      <v-card-title primary-title class="justify-center">
        <div>
          <h3 class="headline text--accent-2">{{ this.title }}</h3>
        </div>
      </v-card-title>

      <v-form>
        <v-text-field
          v-model="email"
          label="Email"
          outlined
          type="email"
          autocomplete="off"
          class="form-field"
        />

        <v-text-field
          v-model="password"
          label="Passwort"
          outlined
          type="password"
          autocomplete="off"
          class="form-field"
        />

        <v-text-field
            v-model="note"
            label="Beschreibung"
            outlined
            type="text"
            autocomplete="off"
            class="form-field"
        />


        <v-select
            v-model="type"
            :items="['group', 'single']"
            label="Type"
            outlined
            class="form-field"
        />

        <v-select
            v-if="type === 'group'"
          v-model="group"
          :items="groups"
          item-text="name"
          item-value="id"
          label="Group"
          outlined
          multiple
          chips
          deletable-chips
          class="form-field"
        />


        <v-text-field
         v-if="type === 'single'"
         v-model="company"
         label="Kunde"
         outlined
         disabled
         class="form-field"

        />

        <v-btn @click="SelectCustomer = true"
               style="margin: 30px;"
               v-if="type == 'single'"
        >
          <v-icon
              style="padding-right: 5px;"
          >mdi-account-box</v-icon>
          Kunden auswählen</v-btn>


        <v-col class="text-right">
          <v-btn
            color="red"
            elevation="2"
            outlined
            class="mr-4"
            @click="btnCancel"
          >
            Abbrechen
          </v-btn>

          <v-btn
            color="green"
            elevation="2"
            outlined
            @click="saveData"
          >
            Speichern
          </v-btn>
        </v-col>
      </v-form>
    </v-card>

<SelectCustomer
  v-if="SelectCustomer"
  @SelectedCustomer="loadCustomer"
  @SelectCustomerReset="SelectCustomer = false"
/>



  </v-layout>



</template>

<style scoped>
.form-field {
  display: table;
  margin: 0 auto;
  width: 350px;
}
</style>